import React, { useState } from "react";
import { BrowserRouter, Link,  } from "react-router-dom";
import $ from "jquery";
import "@fortawesome/fontawesome-svg-core/styles.css";
import SideBar from "../../../components/DashboardComp/Sidebar/SideBar";
import { LogoRadiance } from "../../../constant";
import DashboardRoutes from "../../../routes/DashboardRoutes";
import { ramdomImage } from "../../../constant/ConstantFunction";
import "../../../assets/css/DashboardLayout.css";
import { useSelector } from "react-redux";
import { ImageUrl } from "../../../network/ApiUrl";

function DashboardLayout() {
  const UserData = useSelector((state) => state.AuthReducer.users);
  const [notificationActive, setNotificationActive] = useState(false);

  const $a = document.querySelector("#sidebar-toggle");
  const toggleNavBar = (e) => {
    e.preventDefault();
    document.querySelector("#wrapper").classList.toggle("toggled");
  };



  return (
    <>
      <BrowserRouter>
        <div id="wrapper">
          <div id="navbar-wrapper">
            <nav className="navbar navbar-inverse">
              <div className="container-fluid">
                <div className="navbar-header">
                  <a className="navbar-brand nav_logo">
                    <img src={LogoRadiance} className="image-fluid" />
                  </a>
                </div>
                <div className="navbar-header">
                  <a
                    className="navbar-brand distance-width"
                    id="sidebar-toggle"
                    onClick={(e) => toggleNavBar(e)}
                  >
                    <i className="fa fa-bars"></i>
                  </a>
                </div>

                <div className="navbar-header">
                  <div className="custom-topBar">
                    <ul>
                    
                      {/* <li
                        className={type === "notification" ? "Active" : null}
                        onClick={() => {
                          handleActive(setType("notification"));
                        }}
                      >
                        <Link to="/adminpanel/notification">
                          <FontAwesomeIcon
                            icon={faBullhorn}
                            // className="notification-icon"
                            className={
                              type === "notification"
                                ? "Active"
                                : "notification-icon"
                            }
                          />
                        </Link>
                      </li> */}
                    
                    </ul>
                  </div>
                </div>
                <div className="navbar-header">
                  <div className="profile-container">
                    <Link to="adminpanel/profile">
                      <div className="profile">
                        {UserData?.profile_picture == null ? (
                            <img
                            src={`${ramdomImage(`${UserData?.first_name}`)}`}
                            className="image-fluid image-width"
                            alt=""
                          />
                        ) : (
                          <img
                          src={`${ImageUrl}/${UserData?.profile_picture}`}
                          className="image-fluid image-width"
                          alt=""
                        />
                        )}
                     
                      
                      </div>
                      <div className="ml-2">
                        <p className="navbar-profile-name">
                          {UserData?.first_name}
                        </p>
                        <p className="navbar-profile-role">Admin</p>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </nav>
          </div>
          <aside id="sidebar-wrapper">
            <SideBar />
          </aside>

          <section id="content-wrapper">
            <div className="row">
              <div className="col-lg-12">
                <DashboardRoutes />
              </div>
            </div>
          </section>
        </div>
      </BrowserRouter>
    </>
  );
}

export default DashboardLayout;
